var _rect, _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBearerOnlineCycle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 42,
    viewBox: "0 0 28 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.7719,
    y: 17.193,
    width: 1.96491,
    height: 22.5965,
    rx: 0.982456,
    fill: "#FF8A29"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    fill: "#FF8A29",
    stroke: "#DB7723",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.41228 20.386C7.28143 20.386 6.33351 20.0035 5.56853 19.2385C4.80354 18.4735 4.42105 17.5256 4.42105 16.3947C4.42105 15.2639 4.8102 14.316 5.58849 13.551C6.36677 12.786 7.30804 12.4035 8.41228 12.4035C9.43669 12.4035 10.2981 12.7095 10.9966 13.3215C11.6951 13.9335 12.1374 14.6918 12.3237 15.5965H12.8425L11.4057 11.6053H10.0088V10.0088H14V11.6053H13.1219L13.4013 12.4035H17.2329L16.0754 9.21052H14V7.61403H17.2129L18.9491 12.3636H19.5877C20.692 12.3636 21.6332 12.7527 22.4115 13.531C23.1898 14.3093 23.5789 15.2506 23.5789 16.3548C23.5789 17.4724 23.1931 18.4236 22.4215 19.2085C21.6499 19.9935 20.7053 20.386 19.5877 20.386C18.6298 20.386 17.7883 20.0866 17.0633 19.4879C16.3382 18.8893 15.8759 18.1243 15.6763 17.193H12.3237C12.1374 18.111 11.6851 18.8726 10.9667 19.478C10.2482 20.0833 9.39678 20.386 8.41228 20.386ZM8.41228 18.7895C8.95775 18.7895 9.42672 18.6398 9.81919 18.3405C10.2117 18.0411 10.4877 17.6586 10.6474 17.193H8.41228V15.5965H10.6474C10.4877 15.1175 10.2117 14.7317 9.81919 14.439C9.42672 14.1463 8.95775 14 8.41228 14C7.73377 14 7.16502 14.2295 6.70603 14.6885C6.24704 15.1475 6.01754 15.7162 6.01754 16.3947C6.01754 17.0599 6.24704 17.6254 6.70603 18.091C7.16502 18.5566 7.73377 18.7895 8.41228 18.7895ZM14.5588 15.5965H15.6763C15.7428 15.2905 15.8326 15.0045 15.9457 14.7384C16.0588 14.4723 16.2085 14.2262 16.3947 14H13.9601L14.5588 15.5965ZM19.5877 18.7895C20.2662 18.7895 20.835 18.5566 21.294 18.091C21.753 17.6254 21.9825 17.0599 21.9825 16.3947C21.9825 15.7162 21.753 15.1475 21.294 14.6885C20.835 14.2295 20.2662 14 19.5877 14H19.5079L20.3061 16.1153L18.7895 16.6741L18.0311 14.5588C17.7651 14.7849 17.5588 15.051 17.4125 15.357C17.2662 15.663 17.193 16.0089 17.193 16.3947C17.193 17.0599 17.4225 17.6254 17.8815 18.091C18.3405 18.5566 18.9092 18.7895 19.5877 18.7895Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_54"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.1579,
    height: 19.1579,
    fill: "white",
    transform: "translate(4.42105 4.42105)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBearerOnlineCycle);
export default __webpack_public_path__ + "static/media/bearer-online-cycle.fe28b65783d6cd2418f9ef97361a627c.svg";
export { ForwardRef as ReactComponent };